import { all, call, put, takeEvery } from "redux-saga/effects";

import * as t from "./actionType";
import * as a from "./action";

import {
  // report
  getSerpReportList,
  getSerpReportData,
  createSerpReport,
  updateSerpReport,
  deleteSerpReport,
  runSerpReport,
  getSerpReportPdf,
  getSerpReportSnapshotPdf,
  emailSerpReport,
  // item
  getSerpItemList,
  getSerpItemData,
  createSerpItem,
  updateSerpItem,
  deleteSerpItem,
  // snapshot
  getSerpSnapshotList,
  getSerpSnapshotData,
  deleteSerpSnapshot,
  // result
  getSerpResultBySnapshot,
  getSerpResultByItem,
  getSerpResultData,
  getSerpResultOrganic,
} from "../../helpers/fakebackend_helper";

// ---------- REPORT ----------
function* reportListSaga() {
  try {
    yield put(a.serpReportListSuccess(yield call(getSerpReportList)));
  } catch (e) {
    yield put(a.serpReportListFail(e));
  }
}
function* reportDataSaga({ data }) {
  try {
    yield put(a.serpReportDataSuccess(yield call(getSerpReportData, data)));
  } catch (e) {
    yield put(a.serpReportDataFail(e));
  }
}
function* reportCreateSaga({ data }) {
  try {
    yield put(a.serpReportCreateSuccess(yield call(createSerpReport, data)));
  } catch (e) {
    yield put(a.serpReportCreateFail(e));
  }
}
function* reportUpdateSaga({ data }) {
  try {
    yield put(a.serpReportUpdateSuccess(yield call(updateSerpReport, data)));
  } catch (e) {
    yield put(a.serpReportUpdateFail(e));
  }
}
function* reportDeleteSaga({ data }) {
  try {
    yield put(a.serpReportDeleteSuccess(yield call(deleteSerpReport, data)));
  } catch (e) {
    yield put(a.serpReportDeleteFail(e));
  }
}
function* reportRunSaga({ data }) {
  try {
    yield put(a.serpReportRunSuccess(yield call(runSerpReport, data)));
  } catch (e) {
    yield put(a.serpReportRunFail(e));
  }
}
function* reportPdfSaga({ data }) {
  try {
    yield put(a.serpReportPdfSuccess(yield call(getSerpReportPdf, data)));
  } catch (e) {
    yield put(a.serpReportPdfFail(e));
  }
}
function* reportSnapshotPdfSaga({ data }) {
  try {
    yield put(
      a.serpReportSnapshotPdfSuccess(yield call(getSerpReportSnapshotPdf, data))
    );
  } catch (e) {
    yield put(a.serpReportSnapshotPdfFail(e));
  }
}
function* reportEmailSaga({ data }) {
  try {
    yield put(a.serpReportEmailSuccess(yield call(emailSerpReport, data)));
  } catch (e) {
    yield put(a.serpReportEmailFail(e));
  }
}

// ---------- ITEM ----------
function* itemListSaga({ data }) {
  try {
    yield put(a.serpItemListSuccess(yield call(getSerpItemList, data)));
  } catch (e) {
    yield put(a.serpItemListFail(e));
  }
}
function* itemDataSaga({ data }) {
  try {
    yield put(a.serpItemDataSuccess(yield call(getSerpItemData, data)));
  } catch (e) {
    yield put(a.serpItemDataFail(e));
  }
}
function* itemCreateSaga({ data }) {
  try {
    yield put(a.serpItemCreateSuccess(yield call(createSerpItem, data)));
  } catch (e) {
    yield put(a.serpItemCreateFail(e));
  }
}
function* itemUpdateSaga({ data }) {
  try {
    yield put(a.serpItemUpdateSuccess(yield call(updateSerpItem, data)));
  } catch (e) {
    yield put(a.serpItemUpdateFail(e));
  }
}
function* itemDeleteSaga({ data }) {
  try {
    yield put(a.serpItemDeleteSuccess(yield call(deleteSerpItem, data)));
  } catch (e) {
    yield put(a.serpItemDeleteFail(e));
  }
}

// ---------- SNAPSHOT ----------
function* snapshotListSaga({ data }) {
  try {
    yield put(a.serpSnapshotListSuccess(yield call(getSerpSnapshotList, data)));
  } catch (e) {
    yield put(a.serpSnapshotListFail(e));
  }
}
function* snapshotDataSaga({ data }) {
  try {
    yield put(a.serpSnapshotDataSuccess(yield call(getSerpSnapshotData, data)));
  } catch (e) {
    yield put(a.serpSnapshotDataFail(e));
  }
}
function* snapshotDeleteSaga({ data }) {
  try {
    yield put(a.serpSnapshotDeleteSuccess(yield call(deleteSerpSnapshot, data)));
  } catch (e) {
    yield put(a.serpSnapshotDeleteFail(e));
  }
}

// ---------- RESULT ----------
function* resultBySnapshotSaga({ data }) {
  try {
    yield put(
      a.serpResultBySnapshotSuccess(yield call(getSerpResultBySnapshot, data))
    );
  } catch (e) {
    yield put(a.serpResultBySnapshotFail(e));
  }
}
function* resultByItemSaga({ data }) {
  try {
    yield put(a.serpResultByItemSuccess(yield call(getSerpResultByItem, data)));
  } catch (e) {
    yield put(a.serpResultByItemFail(e));
  }
}
function* resultDataSaga({ data }) {
  try {
    yield put(a.serpResultDataSuccess(yield call(getSerpResultData, data)));
  } catch (e) {
    yield put(a.serpResultDataFail(e));
  }
}
function* resultOrganicSaga({ data }) {
  try {
    yield put(a.serpResultOrganicSuccess(yield call(getSerpResultOrganic, data)));
  } catch (e) {
    yield put(a.serpResultOrganicFail(e));
  }
}

function* Serp() {
  yield all([
    // report
    takeEvery(t.SERP_REPORT_LIST, reportListSaga),
    takeEvery(t.SERP_REPORT_DATA, reportDataSaga),
    takeEvery(t.SERP_REPORT_CREATE, reportCreateSaga),
    takeEvery(t.SERP_REPORT_UPDATE, reportUpdateSaga),
    takeEvery(t.SERP_REPORT_DELETE, reportDeleteSaga),
    takeEvery(t.SERP_REPORT_RUN, reportRunSaga),
    takeEvery(t.SERP_REPORT_PDF, reportPdfSaga),
    takeEvery(t.SERP_REPORT_SNAPSHOT_PDF, reportSnapshotPdfSaga),
    takeEvery(t.SERP_REPORT_EMAIL, reportEmailSaga),
    // item
    takeEvery(t.SERP_ITEM_LIST, itemListSaga),
    takeEvery(t.SERP_ITEM_DATA, itemDataSaga),
    takeEvery(t.SERP_ITEM_CREATE, itemCreateSaga),
    takeEvery(t.SERP_ITEM_UPDATE, itemUpdateSaga),
    takeEvery(t.SERP_ITEM_DELETE, itemDeleteSaga),
    // snapshot
    takeEvery(t.SERP_SNAPSHOT_LIST, snapshotListSaga),
    takeEvery(t.SERP_SNAPSHOT_DATA, snapshotDataSaga),
    takeEvery(t.SERP_SNAPSHOT_DELETE, snapshotDeleteSaga),
    // result
    takeEvery(t.SERP_RESULT_BY_SNAPSHOT, resultBySnapshotSaga),
    takeEvery(t.SERP_RESULT_BY_ITEM, resultByItemSaga),
    takeEvery(t.SERP_RESULT_DATA, resultDataSaga),
    takeEvery(t.SERP_RESULT_ORGANIC, resultOrganicSaga),
  ]);
}

export default Serp;
